var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component"},[(_vm.showDate)?[_vm._v(" "+_vm._s(_vm.date)),(_vm.multiline)?_c('br'):_c('span',[_vm._v(" ")])]:_vm._e(),(_vm.showTime)?[_vm._v(" "+_vm._s(_vm.time)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }